document.addEventListener("DOMContentLoaded", function () {

    const tabDeliveryGeneral = document.getElementById('tab-general');
    const tabDeliveryAddress = document.getElementById('tab-delivery-address');
    const tabDeliveryBilling = document.getElementById('tab-delivery-billing');
    const tabDeliveryPayment = document.getElementById('tab-delivery-payment');

    var goToDeliveryAddressButton = document.getElementById("go-to-delivery-address-tab");
    var goToDeliveryBillingButton = document.getElementById("go-to-delivery-billing-tab");
    var goToDeliveryPaymentButton = document.getElementById("go-to-delivery-payment-tab");

    var returnToGeneralButton = document.getElementById("return-to-general-tab");
    var returnToDeliveryAddressButton = document.getElementById("return-to-delivery-address-tab");
    var returnToDeliveryBillingButton = document.getElementById("return-to-delivery-billing-tab");

    var goToPaymentButton = $('#go-to-payment');
    var responseInfoPayment = $('#response-info-payment');

    var goToPayment = document.getElementById("go-to-payment")

    if (goToDeliveryAddressButton) {
        goToDeliveryAddressButton.addEventListener("click", function () {
            let allowTabChange = false;
            $(goToDeliveryAddressButton).prop('disabled', true);

            var notCustomerInfoElements = document.querySelectorAll('.not-customer-info');
            if (notCustomerInfoElements.length > 0) {
                var nameInput = document.getElementById('name');
                var surnameInput = document.getElementById('surname');
                var phoneInput = document.getElementById('phone');
                var emailInput = document.getElementById('email');
                var reemailInput = document.getElementById('reemail');
                var passwordInput = document.getElementById('password');
                var repasswordInput = document.getElementById('repassword');

                function isFieldEmpty(inputElement) {
                    return inputElement.value.trim() === '';
                }

                function areAllFieldsFilled() {
                    return (!isFieldEmpty(nameInput) &&
                        // !isFieldEmpty(surnameInput) &&
                        !isFieldEmpty(phoneInput) &&
                        !isFieldEmpty(emailInput) &&
                        !isFieldEmpty(reemailInput)
                    );
                }

                function validateEmailMatch() {
                    if (emailInput.value === reemailInput.value) {
                        return true;
                    }
                    return false;
                }

                function validatePasswordMatch() {
                    if((passwordInput.value.length > 0) || (repasswordInput.value.length > 0)) {
                        if (passwordInput.value.length < 6) {
                            // minimo 6 caracteres de tener algo uno de los dos campos
                            return false;
                        }
                        if (repasswordInput.value.length < 6) {
                            // minimo 6 caracteres de tener algo uno de los dos campos
                            return false;
                        }
                        if (passwordInput.value === repasswordInput.value) {
                            // Son identicas
                            return true;
                        }

                        // cualquie otro caso será que falta uno de los dos campos ("esta vacio 1 de los 2")
                        return false;
                    }

                    // Estan vacios los dos campos y son opcionales, se le deja pasar
                    return true;
                }

                axios
                    .post(route('ajax.checkRegisteredEmail', { email: emailInput.value }))
                    .then(function (response) {

                        if (response.data) {

                            $('#response-info-customers').html('<span class="text-danger">Ya te encuentras registrado, por favor ingresa con tus credenciales para comprar</span>');

                        } else {

                            if (!validateEmailMatch()) {
                                $('#response-info-customers').html('<span class="text-danger">Email facilitado no válido, ambos emails deben ser idénticos.</span>');
                                return;
                            }

                            if (!validatePasswordMatch()) {
                                $('#response-info-customers').html('<span class="text-danger">La password no es válida, ambas passwords deben ser idénticas y tener un mínimo de 6 caracteres.</span>');
                                return;
                            }

                            if (!areAllFieldsFilled()) {
                                $('#response-info-customers').html('<span class="text-danger">Debes rellenar todos los campos</span>');
                                return;
                            }

                            allowTabChange = true;
                        }

                        if (allowTabChange) {
                            $('#response-info-customers').empty();
                            $(goToDeliveryAddressButton).prop('disabled', false);
                            tabDeliveryAddress.classList.remove('disabled');
                            tabDeliveryAddress.click();
                        }

                    })
                    .catch(function (error) {
                        console.error('Hubo un error en la verificación del email: ', error);
                    });
            }else{
                $('#response-info-customers').empty();
                $(goToDeliveryAddressButton).prop('disabled', false);
                tabDeliveryAddress.classList.remove('disabled');
                tabDeliveryAddress.click();
            }
        });
    }

    if (goToDeliveryBillingButton) {
        goToDeliveryBillingButton.addEventListener("click", function () {
            $('#response-info-collect-store').html('');
            $('#response-info-order-address').html('');
            $('#response-message').html('');

            var selectedOption = $('input[name="radio_entrega"]:checked').val();
            var postalCodeInput = document.getElementById('postal_code');
            var addressLineInput = document.getElementById('address_line');
            var addressLineValue = addressLineInput.value;
            var shopSelect = document.getElementById('shop');
            var selectedShopValue = shopSelect.value;            

            goToPaymentButton.disabled = true;

            // Check if "entrega a domilio" is selected and the check if Postal Code is not empty
            var element_radio_entrega1 = document.getElementById("radio_entrega1");
            if (element_radio_entrega1.checked) {
                if (postalCodeInput.length === 0) {
                    console.log("No definido");
                } else if (postalCodeInput === null) {
                    console.log("Null");
                } else {

                    if (postalCodeInput.value === "") {
                        goToPaymentButton.disabled = true;
                        console.log("codigo postal vacio");
                        $('#response-info-postal_code').html('<span class="text-danger">Debes introducir un código postal</span>');

                        // Set timeout to leave the chage and reset again
                        let myTimeoutChange1 = setTimeout(() => {
                            $('#response-info-customers').empty();
                            $(goToDeliveryAddressButton).prop('disabled', false);
                            tabDeliveryAddress.classList.remove('disabled');
                            tabDeliveryAddress.click();

                            $('#delivery-billing-tab').attr('class', 'tab-pane show');
                            $('#delivery-address-tab').attr('class', 'tab-pane show active');
                        }, 15);
                    }
                    else {
                        if ($("#send_product_form").is(":hidden")) {

                            goToPaymentButton.disabled = true;
                            console.log("codigo postal vacio");
                            $('#response-info-postal_code').html('<span class="text-danger">Debes introducir un código postal</span>');

                            // Set timeout to leave the chage and reset again
                            let myTimeoutChange2 = setTimeout(() => {
                                $('#response-info-customers').empty();
                                $(goToDeliveryAddressButton).prop('disabled', false);
                                tabDeliveryAddress.classList.remove('disabled');
                                tabDeliveryAddress.click();

                                $('#delivery-billing-tab').attr('class', 'tab-pane show');
                                $('#delivery-address-tab').attr('class', 'tab-pane show active');
                            }, 15);

                        }                        
                    }

                }
            }

            if (selectedOption === 'domicilio') {
                $('#response-info-collect-store').html('');
                $('#response-info-order-address').html('');
                $('#response-message').html('');

                if (addressChangedValue() && cityChangedValue()) {
                    tabDeliveryBilling.classList.remove('disabled');
                    tabDeliveryBilling.click();
                } else {
                    goToPaymentButton.disabled = true;
                    tabDeliveryBilling.classList.add('disabled');
                    $('#response-info-order-address').html('<span class="text-danger">Debes seleccionar una dirección</span>');
                }
            } else {
                $('#response-info-collect-store').html('');
                $('#response-info-order-address').html('');
                $('#response-message').html('');
                if (selectedShopValue !== '') {
                    tabDeliveryBilling.classList.remove('disabled');
                    tabDeliveryBilling.click();
                } else {
                    tabDeliveryBilling.classList.add('disabled');
                    $(goToDeliveryBillingButton).prop('disabled', true);
                    $('#response-info-collect-store').html('<span class="text-danger">Debes elegir una tienda</span>');
                    $('#response-message').html('');
                }
            }
        });
    }

    if (goToDeliveryPaymentButton) {
        goToDeliveryPaymentButton.addEventListener("click", function () {
            var billOptionValue = $('input[name="bill_option"]:checked').val();
            tabDeliveryPayment.classList.add('disabled');

            if (billOptionValue == 'bill_not') {

                tabDeliveryPayment.classList.remove('disabled');
                tabDeliveryPayment.click();
                $('#response-info-billing').empty();
                $('#response-extension-billing-file').empty();

            } else {

                var cfdiValue = $('#cfdi_id').val();
                var paymentValue = $('#payment_id').val();
                var billFileValue = $('#table_file').val();
                var inputElement = document.getElementById('file_list');
                var value = inputElement.value;
                function containsValidFile(value) {
                    try {
                        var fileList = JSON.parse(value);
                        return fileList.some(file => {
                            return file.name && (
                                file.name.endsWith(".pdf") ||
                                file.name.endsWith(".docx") ||
                                file.name.endsWith(".doc")
                            );
                        });
                    } catch (e) {
                        $('#response-extension-billing-file').html('<span class="text-danger">Debes subir un formato válido (pdf, doc, docx ...)</span>');
                        return false;
                    }
                }

                if (cfdiValue !== '' && paymentValue !== '' && containsValidFile(value)) {
                    tabDeliveryPayment.classList.remove('disabled');
                    tabDeliveryPayment.click();
                    $('#response-info-billing').empty();
                    $('#response-extension-billing-file').empty();

                } else {
                    tabDeliveryPayment.classList.add('disabled');
                    $(goToDeliveryPaymentButton).prop('disabled', true);
                    $('#response-info-billing').html('<span class="text-danger">Debes elegir  CFDI, Método de Pago y subir un archivo de tu información fiscal</span>');
                }

            }

        });
    }


    // self executing function here
    (function() {
        // your page initialization code here
        // the DOM will be available here
        let myTimeout = setTimeout(myRecurrentRefresh, 150);

        function myRecurrentRefresh() {

            var notCustomerInfoElements = document.querySelectorAll('.not-customer-info');
            if (notCustomerInfoElements.length > 0) {

                let element_name = document.getElementById("name");
                let element_resume_name = document.getElementById("resume_name");

                let element_phone = document.getElementById("phone");
                let element_resume_phone = document.getElementById("resume_phone");

                let element_email = document.getElementById("email");
                let element_resume_email = document.getElementById("resume_email");

                if(element_name) {
                    if(element_resume_name) {
                        element_resume_name.innerHTML = element_name.value;
                    }
                }

                if(element_phone) {
                    if(element_resume_phone) {
                        element_resume_phone.innerHTML = element_phone.value;
                    }
                }

                if(element_email) {
                    if(element_resume_email) {
                        element_resume_email.innerHTML = element_email.value;
                    }
                }

                let element_user_info = document.getElementById("user_info");
                if(element_user_info) {
                    element_user_info.style.display = "block";
                }

            }
            else {
                let element_user_info = document.getElementById("user_info");
                if(element_user_info) {
                    element_user_info.style.display = "none";
                }
            }

            let element_radio_entrega1 = document.getElementById("radio_entrega1");
            let element_radio_entrega2 = document.getElementById("radio_entrega2");

            if (element_radio_entrega1.checked) {
                // ENVIO A DOMICILIO
                document.getElementById("envio_a_domicilio").style.display = "block";
                document.getElementById("envio_a_recogida_en_tienda").style.display = "none";

                let element_resume_delivery_type_1 = document.getElementById("resume_delivery_type_1");
                element_resume_delivery_type_1.innerHTML = "Envío a domicilio";

                let element_postal_code = document.getElementById("postal_code");
                let element_resume_postal_code = document.getElementById("resume_postal_code");

                let element_address_line = document.getElementById("address_line");
                let element_resume_address_line = document.getElementById("resume_street");

                let element_colony = document.getElementById("colony");
                let element_resume_colony = document.getElementById("resume_colony");

                let element_city = document.getElementById("city");
                let element_resume_city = document.getElementById("resume_city");

                let element_state = document.getElementById("country_id");
                let element_resume_state = document.getElementById("resume_state");

                let element_references = document.getElementById("references");
                let element_resume_references = document.getElementById("resume_references");

                element_resume_postal_code.innerHTML = element_postal_code.value;
                element_resume_address_line.innerHTML = element_address_line.value;
                element_resume_colony.innerHTML = element_colony.value;
                element_resume_city.innerHTML = element_city.value;
                element_resume_state.innerHTML = element_state.options[element_state.selectedIndex].text;
                element_resume_references.innerHTML = element_references.value;

                let element_ya_con_envio_text1 = document.getElementById("ya_con_envio_text_1");
                if (element_ya_con_envio_text1 !== null) {
                    element_ya_con_envio_text1.style.display = "block";
                }

                let element_ya_con_envio_text2 = document.getElementById("ya_con_envio_text_2");
                if (element_ya_con_envio_text2 !== null) {
                    element_ya_con_envio_text2.style.display = "block";
                }
            }
            else if (element_radio_entrega2.checked) {
                // RECOGIDA EN TIENDA
                document.getElementById("envio_a_domicilio").style.display = "none";
                document.getElementById("envio_a_recogida_en_tienda").style.display = "block";

                let element_resume_delivery_type_2 = document.getElementById("resume_delivery_type_2");
                element_resume_delivery_type_2.innerHTML = "Recogida en tienda";

                let element_state_shop = document.getElementById("state-dealers");
                let element_resume_state = document.getElementById("resume_state_shop");

                if (element_state_shop.length === 0) {
                    console.log("No definido");
                } else if (element_state_shop[0] === null) {
                    console.log("Null");
                } else {
                    if (element_state_shop.selectedIndex !== -1) {
                        // console.log(element_shop_shop.options[element_shop_shop.selectedIndex].text);
                        element_resume_state.innerHTML = element_state_shop.options[element_state_shop.selectedIndex].text;
                    }
                }

                let element_shop_shop = document.getElementById('shop');
                let element_resume_shop = document.getElementById("resume_shop_shop");

                if (element_shop_shop.length === 0) {
                    console.log("No definido");
                } else if (element_shop_shop === null) {
                    console.log("Null");
                } else {
                    if (element_shop_shop.selectedIndex !== -1) {
                        // console.log(element_shop_shop.options[element_shop_shop.selectedIndex].text);
                        element_resume_shop.innerHTML = element_shop_shop.options[element_shop_shop.selectedIndex].text;
                    }
                }

                let element_ya_con_envio_text1 = document.getElementById("ya_con_envio_text_1");
                if (element_ya_con_envio_text1 !== null) {
                    element_ya_con_envio_text1.style.display = "none";
                }

                let element_ya_con_envio_text2 = document.getElementById("ya_con_envio_text_2");
                if (element_ya_con_envio_text2 !== null) {
                    element_ya_con_envio_text2.style.display = "none";
                }
            }


            let element_radio_bill_yes = document.getElementById("radio_bill_yes");
            let element_radio_bill_no = document.getElementById("radio_bill_not");

            if (element_radio_bill_yes.checked){
                // SI QUIERO FACTURA
                document.getElementById("factura_si").style.display = "block";
                document.getElementById("factura_no").style.display = "none";

                let element_cfdi_id = document.getElementById("cfdi_id");
                let element_resume_cfdi_id = document.getElementById("resume_cfdi_use");

                if (element_cfdi_id.length === 0) {
                    console.log("No definido");
                } else if (element_cfdi_id === null) {
                    console.log("Null");
                } else {
                    if (element_cfdi_id.selectedIndex !== -1) {
                        // console.log(element_cfdi_id.options[element_cfdi_id.selectedIndex].text);
                        element_resume_cfdi_id.innerHTML = element_cfdi_id.options[element_cfdi_id.selectedIndex].text;
                    }
                }

                let element_payment_method = document.getElementById("payment_id");
                let element_resume_payment_method = document.getElementById("resume_payment_method");

                if (element_payment_method.length === 0) {
                    console.log("No definido");
                } else if (element_payment_method === null) {
                    console.log("Null");
                } else {
                    if (element_payment_method.selectedIndex !== -1) {
                        // console.log(element_payment_method.options[element_payment_method.selectedIndex].text);
                        element_resume_payment_method.innerHTML = element_payment_method.options[element_payment_method.selectedIndex].text;
                    }
                }

            }
            else if (element_radio_bill_no.checked){
                // NO QUIERO FACTURA
                document.getElementById("factura_si").style.display = "none";
                document.getElementById("factura_no").style.display = "block";                
            }


            let elementFinalPriceShowed = document.getElementById("modal-calculatedPrice-res");
            let elementFinalPriceHidden = document.getElementById("finalPrice");
            if(elementFinalPriceShowed){
                if(elementFinalPriceHidden){
                    elementFinalPriceHidden.value = elementFinalPriceShowed.innerHTML;
                }
            }

            clearTimeout(myTimeout);
            myTimeout = setTimeout(myRecurrentRefresh, 150);
        }

    })();

    if (goToPayment) {
        goToPayment.addEventListener("click", function () {
            var paymentValue2 = $('#payment_id2').val();

            if (paymentValue2 == '') {
                goToPaymentButton.prop('disabled', true);
                responseInfoPayment.html('<span class="text-danger">Debes seleccionar tu Método de Pago</span>');
            } else {
                goToPaymentButton.prop('disabled', false);
                responseInfoPayment.html('');
            }
        });

        $('#payment_id2').on('change', function () {
            var paymentValue2 = $(this).val();

            if (paymentValue2 == '') {
                goToPaymentButton.prop('disabled', true);
                responseInfoPayment.html('<span class="text-danger">Debes seleccionar tu Método de Pago</span>');
            } else {
                goToPaymentButton.prop('disabled', false);
                responseInfoPayment.html('');
            }
        });
    }

    if (returnToGeneralButton) {
        returnToGeneralButton.addEventListener("click", function () {
            tabDeliveryGeneral.click()
        });
    }

    if (returnToDeliveryAddressButton) {
        returnToDeliveryAddressButton.addEventListener("click", function () {
            tabDeliveryAddress.click()
        });
    }

    if (returnToDeliveryBillingButton) {
        returnToDeliveryBillingButton.addEventListener("click", function () {
            tabDeliveryBilling.click()
        });
    }

    function addressChangedValue() {
        var addressLineInput = document.getElementById('address_line');
        var addressLineValue = addressLineInput.value;
        if (addressLineValue.trim().length > 4) {
            $('#response-info-order-address').html('')
            return true;
        } else {
            $('#response-info-order-address').html('<span class="text-danger">La dirección está vacía</span>')
            return false;
        }
    }

    function cityChangedValue() {
        var cityLineInput = document.getElementById('city');
        var cityLineValue = cityLineInput.value;

        if (cityLineValue.trim().length > 1) {
            $('#response-info-order-address').html('')
            return true;
        } else {
            $('#response-info-order-address').html('<span class="text-danger">La ciudad está vacía</span>')
            return false;
        }
    }

    // Update the order summary when an input field is changed
    var idsFuente = [
        'quantity-display',
        'modal-calculatedPrice',
        'modal-total-calculated'
    ];

    function updateContentTarget(idSource) {
        var contentSource = document.getElementById(idSource).textContent;
        var idTarget = idSource + '-res';
        var target = document.getElementById(idTarget);
        target.textContent = contentSource;
    }

    var config = { childList: true, subtree: true, characterData: true };

    idsFuente.forEach(function(idSource) {
        var observer = new MutationObserver(function() {
            updateContentTarget(idSource);
        });

        var fuente = document.getElementById(idSource);
        observer.observe(fuente, config);
    });
});
